import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  setSelectedClass,
  setSelectedSKUs,
  setSelectedWeekStart,
  setSelectedWeekEnd,
} from "../../../Redux/promoSimulatorSlice/promoSimulatorSlice";

export default function ClassSelector({ classes = [], formControlSx, loading = false }) {
  const dispatch = useDispatch();
  const selectedClass = useSelector((state) => state.promoSimulator.selectedClass);

  const handleChange = (e) => {
    dispatch(setSelectedClass(e.target.value || null));
    dispatch(setSelectedSKUs([]));
    dispatch(setSelectedWeekStart(null));
    dispatch(setSelectedWeekEnd(null));
  };

  const valueInOptions = classes.some((c) => c.id === selectedClass);
  const selectValue = loading || !valueInOptions ? "" : selectedClass;

  return (
    <FormControl fullWidth size="small" sx={formControlSx} disabled={loading}>
      <InputLabel>Class</InputLabel>
      <Select value={selectValue} label="Class" onChange={handleChange} displayEmpty>
        {classes.map((c) => (
          <MenuItem key={c.id} value={c.id}>
            {c.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

